const Snap = require('snapsvg');
const LoadJSON = require('../../../viscomjs/load/LoadJSON');
const Storage = require('./Storage');

function ProjectPreload(progressUpdate, loadMap, loadSVG) {
    return new Promise(resolve => {
        const __setProgress = function(value) {
            return doThat => {
                return new Promise(resolve => {
                    progressUpdate({progress: value});
                    resolve(doThat);
                });
            };
        };

        let promise = new Promise(resolve => {
            setTimeout(() => {
                resolve(true);
            }, 50);
        });
        if ((!loadMap || loadMap.length < 1) && (!loadSVG || loadSVG.length < 1)) {
            promise.then(__setProgress(100)).then(resources => {
                resolve(resources);
            });
        }

        const __loadJSON = function(id, url) {
            return doThat => {
                return LoadJSON(id, url, false, doThat);
            };
        };

        const __loadSVG = function(id, url) {
            return doThat => {
                return new Promise(resolve => {
                    if (!doThat) {
                        resolve(null);
                        return;
                    }
                    Snap.load(url, f => {
                        Storage.instance().addItem(id, f);
                        resolve(f);
                    });
                });
            };
        };

        let i;
        let p = 0;
        const delta = 100 / ((loadMap ? loadMap.length : 0) + (loadSVG ? loadSVG.length : 0));

        if (loadSVG && loadSVG.length > 0) {
            for (i = 0; i < loadSVG.length; i++) {
                p += i * delta;
                promise = promise.then(__setProgress(p)).then(__loadSVG(...loadSVG[i]));
            }
        }

        if (loadMap && loadMap.length > 0) {
            for (i = 0; i < loadMap.length; i++) {
                p += i * delta;
                promise = promise.then(__setProgress(p)).then(__loadJSON(...loadMap[i]));
            }
        }

        promise.then(__setProgress(100)).then(resources => {
            resolve(resources);
        });
    });
}

module.exports = ProjectPreload;
